import * as dataAccess from 'app/utils/ajax';
import { API_CONSTANTS } from 'app/constants/api-contants';
import { fetchData } from './comonsearch';

export const getGameList = async (param) => {
  const baseUrl = `${API_CONSTANTS.GAME}/list`;
  let responseObj = await fetchData(baseUrl, param);
  return responseObj;
};

export const getGameDetail = async (id) =>
  dataAccess.get(`${API_CONSTANTS.GAME}/detail?id=${id}`);

export const getAvailableGames = async () =>
  dataAccess.get(`${API_CONSTANTS.GAME}/available`);

export const addGame = async (incomingData) =>
  dataAccess.post(`${API_CONSTANTS.GAME}/add`, {
    data: { ...incomingData },
  });

export const updateGame = async (id, incomingData) =>
  dataAccess.put(`${API_CONSTANTS.GAME}/update?id=${id}`, {
    data: { ...incomingData },
  });

export const toggleGameEnabled = async (id, isEnabled) =>
  dataAccess.put(`${API_CONSTANTS.GAME}/disable-enable?id=${id}`, {
    data: { isEnabled },
  });

export const updateGameConfig = async (id, config) =>
  dataAccess.put(`${API_CONSTANTS.GAME}/config?id=${id}`, {
    data: { config },
  });

export const addCampaign = async (incomingData) =>
  dataAccess.post(`${API_CONSTANTS.GAME}/campaign-add`, {
    data: { ...incomingData },
  });

export const updateCampaign = async (id, incomingData) =>
  dataAccess.put(`${API_CONSTANTS.GAME}/campaign-update?id=${id}`, {
    data: { ...incomingData },
  });

export const getCampaignsByGame = async (gameId) =>
  dataAccess.get(`${API_CONSTANTS.GAME}/campaign-list?gameId=${gameId}`);

export const getGameLeaderboard = async (id, params = {}) => {
  const qs = new URLSearchParams(
    Object.entries(params).filter(
      ([, v]) => v !== undefined && v !== null && v !== ''
    )
  ).toString();
  return dataAccess.get(
    `${API_CONSTANTS.GAME}/${id}/leaderboard${qs ? `?${qs}` : ''}`
  );
};

export const resetGameScores = async (id) =>
  dataAccess.post(`${API_CONSTANTS.GAME}/reset-scores?id=${id}`, {
    data: {},
  });

export async function uplaodMedia(file) {
  let formData = new FormData();
  formData.append('image', file);
  let payload = {
    data: formData,
  };

  let responseObj = await dataAccess.upload(
    `${API_CONSTANTS.MEDIA_UPLOAD}`,
    payload
  );

  return responseObj;
}
